//#region import
import React, { useEffect, useState } from 'react'
import { Chip, Divider, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
import { EnumStatus } from '../AdminUser/Role/RoleList';
import { BtnBack } from 'components/Button/ButtonAll';
import { Groups } from '@mui/icons-material';
import DialogPreview from 'components/DialogPreview/DialogPreview';
//#endregion

const CommitteeList = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/BasicInformationList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [arrYear, setYear] = useState<any>([]);
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [arrMaterialUnit, setMaterialUnit] = useState<any>([]);
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [lstUser, setlstUser] = useState([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const onOpenModal = (e, nCommitteeTypeID) => {
        setisOpen(true);
        let param = {
            sID: e,
            nCommitteeTypeID: nCommitteeTypeID
        };
        AxiosFn.Post(`Committee/GetDataUser`, param, (res) => {
            setlstUser(res.lstUserName || []);
        },
            (err) => {
                if (!err.response) {
                    DialogFn.Warning(err.Message);
                }
            }
        );
    };

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate(`/CommitteeForm`)} id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "sYear",
            headerName: " ปี",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
        },
        {
            field: "nRound",
            headerName: "ครั้งที่",
            headerAlign: "center",
            align: "center",
            width: 100,
        },
        {
            field: "nSubcommittee",
            headerName: "อนุกรรมการกลั่นกรองฯ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                if (item.row.nSubcommittee > 0) {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nSubcommittee}</Typography>
                            &nbsp;
                            <Groups
                                sx={{
                                    color: "#f8803d !important",
                                    "&:hover": {
                                        color: "black !important",
                                    },
                                    cursor: "pointer",

                                }}
                                onClick={() => onOpenModal(item.row.sID, 44)}
                            />
                        </>
                    );
                } else {
                    return (
                        <>
                            {/* <Typography variant="body1">{item.row.nSubcommittee}</Typography> */}
                            &nbsp; &nbsp;
                            <Groups
                                sx={{
                                    color: "#d7d7d7 !important",
                                    "&:hover": {
                                        color: "#d7d7d7 !important",
                                    },

                                }}
                            />
                        </>
                    );
                }
            },
        },
        {
            field: "nExecutiveCommittee",
            headerName: "คณะกรรมการบริหาร",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                if (item.row.nExecutiveCommittee > 0) {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nExecutiveCommittee}</Typography>
                            &nbsp;
                            <Groups

                                sx={{
                                    color: "#02a7f0 !important",
                                    "&:hover": {
                                        color: "black !important",
                                    },
                                    cursor: "pointer",

                                }}
                                onClick={() => onOpenModal(item.row.sID, 45)}
                            />
                        </>
                    );
                } else {
                    return (
                        <>
                            {/* <Typography variant="body1">{item.row.nExecutiveCommittee}</Typography> */}
                            &nbsp; &nbsp;
                            <Groups
                                sx={{
                                    color: "#d7d7d7 !important",
                                    "&:hover": {
                                        color: "#d7d7d7 !important",
                                    },

                                }}

                            />
                        </>
                    );
                }
            },
        },
        {
            field: "nTrackingBoard",
            headerName: "คณะกรรมการติดตาม",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            renderCell: (item) => {
                if (item.row.nTrackingBoard > 0) {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nTrackingBoard}</Typography>
                            &nbsp;
                            <Groups
                                sx={{
                                    color: "#02d77d !important",
                                    "&:hover": {
                                        color: "black !important",
                                    },
                                    cursor: "pointer",

                                }}
                                onClick={() => onOpenModal(item.row.sID, 46)}
                            />
                        </>
                    );
                } else {
                    return (
                        <>
                            {/* <Typography variant="body1">{item.row.nTrackingBoard}</Typography> */}
                            &nbsp; &nbsp;
                            <Groups
                                sx={{
                                    color: "#d7d7d7 !important",
                                    "&:hover": {
                                        color: "#d7d7d7 !important",
                                    },

                                }}

                            />
                        </>
                    );
                }
            },
        },
        {
            field: "sEffective",
            headerName: "วันที่มีผลบังคับใช้",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
        },

        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 220,

            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 120,

            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },

    ];

    const getTableCommitteee = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };
        AxiosFn.Post(`Committee/GetTableCommittee`, Param, (result) => {
            setLoadingTable(false);
            setYear(result.lstYear);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataCommitteee],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    useEffect(() => {
        getTableCommitteee(dataRow);

    }, []);

    const goToEdit = (sID: string) => {
        navigate(`/CommitteeForm?sID=${encodeURI(sID)}`);
    };

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "multiselect", sLabel: "ปี", sFieldName: "lstYear", optionSelect: arrYear, nGridLG: 5, nGridMD: 6, nGridSM: 6, nGridXS: 12 },

        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];

    const onDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Committee/RemoveDataTable`, { lstID: e }, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableCommitteee(dataRow);
                    });
                }
            });
        });
    }
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableCommitteee}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    filterField={filter}
                    isShowCheckBox={isPermission}
                    onRowSelectable={(p) => !p.row.isDelete}
                    onDelete={onDelete}
                />
            </Grid>

            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>


            <DialogPreview
                IsOpen={isOpen}
                IsBackdropClick={false}
                onClose={() => { setisOpen(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='sm'
                bgColor={"#a07300"}
                Color='white'
                Title={''}
            >
                <Grid container justifyContent={"center"} >
                    {lstUser.map((m) => (
                        <>
                            <Grid container justifyContent={"center"} xs={12} md={11} spacing={1}>
                                <Grid item xs={6} md={7} >
                                    <Typography style={{ color: "#225192", fontSize: "18px", fontWeight: 500 }}> {m.sCommitteeTypeID} </Typography>
                                </Grid >
                                <Grid item xs={6} md={5}>
                                    <Typography style={{ color: "#225192", fontSize: "18px", fontWeight: 500 }}> ตำแหน่ง </Typography>
                                </Grid >
                            </Grid >
                            <Grid item xs={12} md={12}  >
                                <Divider style={{ color: "#212836" }} />
                            </Grid>
                            {m.lstDate.map((item) => (
                                <>
                                    <Grid container justifyContent={"center"} xs={12} md={11} spacing={1} sx={{ mt: "3px" }}>
                                        <Grid item md={7} >
                                            <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: 400 }}>{item.sUserName} </Typography></Grid >
                                        <Grid item md={5} >
                                            <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: 400 }}> {item.sPosition} </Typography></Grid >
                                    </Grid>
                                </>
                            ))}

                        </>
                    ))}

                </Grid>
            </DialogPreview >
        </React.Fragment >
    )
}
export default CommitteeList;

